import React, { useState } from "react";

import { Button, Menu, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { useTranslation } from 'react-i18next';


export default function NotificationItem({ loadNotifications, notifications, onDelete, userLogin }) {
    const [showModal, setShowModal] = useState(false);

    const { t } = useTranslation();

    const onClickDeleteButton = () => {
        setShowModal(true);
    }
    
    const onClickConfirmDelete = () => {
        onDelete();
        setShowModal(false);
    }
    
    return (
        <Menu className='notification-list'>
            {notifications.length > 0 ? (
                <>
                    <Menu.Item id='deleteAll' className='notification-delete-item'>
                        {showModal ? 
                            <div className="delete-notification-modal">
                                <p>{t('notifications.deleteModal.Title')}</p>
                                <div className="modal-commands">
                                    <Button onClick={() => setShowModal(false)}>{t('notifications.deleteModal.cancelLabelButton')}</Button>
                                    <Button className="delete-button" onClick={onClickConfirmDelete}>{t('notifications.deleteModal.deleteLabelButton')}</Button>
                                </div>
                            </div>
                        :
                            <div className="notification-list-header">
                                <Button onClick={onClickDeleteButton}>Delete all</Button>
                                {loadNotifications && (
                                    <Spin style={{ fontSize: 20, cursor: 'pointer' }} indicator={<LoadingOutlined />} />
                                )}
                            </div>
                        }
                    </Menu.Item>
        
                    {notifications.map((n) => {
                        const createdAtTime = n.createdAt.split(' ')[0];
                        const createdAtTimeType = n.createdAt.split(' ')[1];
                        const notificationContentKey = n.pdmLogin === userLogin ? 'pdmContent' : 'content'
                        const className = `notification-item ${n.viewed ? 'notification-viewed' : 'notification-item'}`

                        return  <Menu.Item key={n.id} className={className}>
                            <span className="notification-item-content">
                                <span className="notification-time">{t(`notifications.time.${createdAtTimeType}`, { time: createdAtTime })}</span><br />
                                <span style={{ color: t(`notifications.${n.type}.titleColor`), fontWeight: 'bold' }}>{t(`notifications.${n.type}.title`)}</span>
                                <div dangerouslySetInnerHTML={{ __html: t(`notifications.${n.type}.${notificationContentKey}`, {
                                        byLogin: `@${n.byLogin}`,
                                        requisitionCode: n.requisitionCode,
                                        requisitionName: n.requisitionName,
                                        collaboratorLogin: `@${n.collaboratorLogin}`
                                    }) 
                                }} 
                                />
                            </span>
                        </Menu.Item>
                    })}
                </>
            ): (
                <Menu.Item className='notification-item no-notification'>
                    <span className="no-notification">{t('notifications.noNotifications')}</span>
                </Menu.Item>
            )}
        </Menu>
    )
}